import { useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';

import { Bonus, CachedBonus, CachedBonuses } from '../../../../../../types/bonus';
import { updateCachedReactions, updateSingleBonusReactions } from '../../../cache/mutators/bonus';
import { QueryKey } from '../../../hooks/types';

export const useReplaceBonus = () => {
	const queryClient = useQueryClient();

	return useCallback(
		(newBonus: Bonus) => {
			queryClient.setQueriesData<CachedBonuses>([QueryKey.BonusesInfinite], (cached) => updateCachedReactions(newBonus.id, newBonus.reactions ?? [], cached));
			queryClient.setQueryData<CachedBonus>([QueryKey.Bonus, newBonus.id], (cached) =>
				updateSingleBonusReactions(newBonus.id, newBonus.reactions ?? [], cached)
			);

			// If this is a child bonus (comment/add-on), also update the parent's single bonus cache
			if (newBonus.parent_bonus_id) {
				queryClient.setQueryData<CachedBonus>([QueryKey.Bonus, newBonus.parent_bonus_id], (cached) =>
					updateSingleBonusReactions(newBonus.id, newBonus.reactions ?? [], cached)
				);
			}
		},
		[queryClient]
	);
};
